import { render, staticRenderFns } from "./UserGroupCoursesTable.vue?vue&type=template&id=360b44e9"
import script from "./UserGroupCoursesTable.vue?vue&type=script&lang=js"
export * from "./UserGroupCoursesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports